import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=6c0ad2ec&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=6c0ad2ec&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ad2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0ad2ec')) {
      api.createRecord('6c0ad2ec', component.options)
    } else {
      api.reload('6c0ad2ec', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=6c0ad2ec&scoped=true", function () {
      api.rerender('6c0ad2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Tabs.vue"
export default component.exports